import $ from 'jquery';
import _ from 'lodash';
import createTemplate from './templates/create.hbs';
import 'webComponents';

// ADD WIDGETS BELOW THIS LINE
import './js/sdaBasicSelect';
import './js/sdaCard';
import './js/sdaCardLargeList';
import './js/sdaDateTime';
import './js/sdaEditor';
import './js/sdaError';
import './js/sdaFilterSelect';
import './js/sdaFlyOver';
import './js/sdaInlineNotification';
import './js/sdaListSelector';
import './js/sdaModal';
import './js/sdaPackageSearch';
import './js/sdaRightPanel';
import './js/sdaSelect';
import './js/sdaSettingLink';
import './js/sdaStatusCard';
import './js/sdaTabs';
import './js/sdaTargeting';
import './js/sdaUpload';

$.fn.sdaInitWidgets = function() {
    _.each(this.find('.sda-fly-over'), function(el) {
        $(el).sdaFlyOver();
    });
    _.each(this.find('div.sda-right-panel, .sda-right-panel-float, .sda-right-panel-new-float'), function(el) {
        $(el).sdaRightPanel();
    });
    _.each(this.find('.sda-card, .sda-graphic-card'), function(el) {
        $(el).sdaCard();
    });
    _.each(this.find('.sda-card-large-list'), function(el) {
        $(el).sdaCardLargeList();
    });
    _.each(this.find('.sda-list-selector, [data-sda-widget=list-selector]'), function(el) {
        $(el).sdaListSelector();
    });
    this.find('.sda-date-time, [data-sda-widget=date-time]').sdaDateTime();
    _.each(this.find('.sda-status-card, [data-sda-widget=status-card]'), function(el) {
        $(el).sdaStatusCard();
    });
    _.each(this.find('.sda-modal-trigger, [data-sda-widget=modal-trigger]'), function(el) {
        $(el).sdaModal();
    });
    this.find('.sda-tabs, .sda-tabs-flex, [data-sda-widget=tabs]').sdaTabs();
    _.each(this.find('.sda-setting-link, [data-sda-widget=setting-link]'), function(el) {
        $(el).sdaSettingLink();
    });
    _.each(this.find('[data-sda-widget=package-search]'), function(el) {
        $(el).sdaPackageSearch();
    });
    _.each(this.find('[data-sda-widget=targeting]'), function(el) {
        $(el).sdaTargeting();
    });
    return this;
};

// Utility Methods
// Creates an empty div so that you can call any widget on it
$.create = function(data) {
    // eslint-disable-next-line no-param-reassign
    data = data || {};
    return $(createTemplate(data));
};

// Trigger the open event for widgets
$.fn.open = function() {
    return this.trigger('open');
};

// Trigger the close event for widgets
$.fn.close = function() {
    return this.trigger('close');
};

// Trigger the toggle.open event for widgets
$.fn.toggleOpen = function() {
    return this.trigger('toggle.open');
};

// Trigger the set event for widgets
$.fn.set = function(val) {
    return this.trigger('set', val);
};

$.fn.disable = function() {
    return this.attr('disabled', '');
};

$.fn.enable = function() {
    return this.removeAttr('disabled');
};

$.fn.attachMethod = function(name, method) {
    const that = this;

    that.data(name, method);
    that[0][name] = method;

    return that;
};

$.fn.scrubDataHTML = function() {
    const that = this;
    let i = 0;
    const dataAttrs = [];
    const attrs = that.get(0).attributes;
    const attrsLen = attrs.length;

    for (; i < attrsLen; i++) {
        if ('data-' === attrs[i].name.substring(0, 5)) {
            dataAttrs.push(attrs[i].name);
            that.data(attrs[i].name.substring(5), attrs[i].value);
        }
    }
    _.each(dataAttrs, function(attr) {
        that.removeAttr(attr);
    });

    return that;
};
